import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import store from './store';
import SiteTooltip from './components/SiteTooltip';
import DmbAutocomplete from './components/DmbAutocomplete';
import DmbCombobox from './components/DmbCombobox';
import helpers from "./plugins/helpers";
import browserDetect from "vue-browser-detect-plugin";

// init validation rules
import "./validation/validations";

Vue.config.productionTip = false;

Vue.use(helpers);
Vue.use(browserDetect);

Vue.directive('dmb-trim', {
  bind: function (el, binding, vnode) {
    vnode.componentInstance.$on('blur', function (event) {
      try {
        let valueToTrim = event.target ? event.target.value : null;
        if (valueToTrim && (typeof valueToTrim) === 'string') {
          valueToTrim = valueToTrim.trim();
          event.target.value = valueToTrim.replace(/[\s]{2,}/g, ' ');
          event.target.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
      catch(ex) {
        // do nothing
      }
    });
  }
});

Vue.component("site-tooltip", SiteTooltip);
Vue.component("dmb-autocomplete", DmbAutocomplete);
Vue.component("dmb-combobox", DmbCombobox);

store.dispatch("checkAuth").then(() => {
    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app');
});
